import Vue from 'vue'
import Vuex from 'vuex'

// Módulos
import { global } from './modules/global'
import { authentication } from './modules/authentication'

Vue.use(Vuex)

export const store = new Vuex.Store({
    modules: {
        global,
        authentication
    }
});